import { Config } from '@optimizely/optimizely-sdk';

import { commonOptimizelyConfig } from './constants/constants';

export const getOptimizelyConfig = (datafile: object): Config => ({
    datafile,
    ...commonOptimizelyConfig,
});
